<template>
	<multiselect 
		v-model="selectedRegion" 
		:id="keyId" 
		label="col_merk_num" 
		track-by="code" 
		placeholder="Pilih device" 
		open-direction="bottom" 
		:options="regions" 
		:multiple="false" 
		:searchable="true" 
		:loading="isLoading" 
		:internal-search="false" 
		:clear-on-select="false" 
		:close-on-select="true" 
		:options-limit="300" 
		:limit="3" 
		:max-height="600" 
		:show-no-results="true" 
		:hide-selected="true" 
		@search-change="asyncFind" 
		@close="closeDropdown" 
		@open="openDropdown" 
		@select="selectDropdown" 
		:select-label="''" 
	/>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
	name: 'SelectOption',
	props: ['keyId', 'defaultId'],
	components: {
		Multiselect
	},
	data() {
		return {
			initRegion: null,
			selectedRegion: null,
			regions: [],
			isLoading: false
		}
	},
	methods: {
		async asyncFind (query) {
	    	let _ = this
	    	this.isLoading = true
	    		if ( _.selectedRegion ) {
	    			_.initRegion = _.selectedRegion
	    		}
	    		_.selectedRegion = null
		      	await _.axios.get('device?limit=5&offset=0&status=1&key=' + query).then(resp => {		      		
		      		_.regions = resp.data.data.rows.data
		      	}).catch(err => {
			      	console.log(err.response)
			    })
		    this.isLoading = false
	    },
		getData(){
			let _ = this
			_.axios.get('device?limit=5&offset=0&status=1').then(resp => {		      		
				_.regions = resp.data.data.rows.data
			}).catch(err => {
				console.log(err.response)
			})
		},
	    getDetail(id) {
	    	let _ = this
	    	if ( id ) {
				_.axios.get('device?limit=5&offset=0&id=' + id).then(resp => {
		      		_.selectedRegion = resp.data.data.rows
		      	}).catch(err => {
			      	console.log(err.response)
			    })
			}
	    },
	    closeDropdown() {
	    	let _ = this
	    	_.selectedRegion = _.initRegion
	    },
	    openDropdown() {
	    	let _ = this
	    	_.initRegion = _.selectedRegion
	    },
	    selectDropdown(value) {
	    	let _ = this
	    	_.initRegion = value
	    }
	},
	mounted() {
		this.getData()
	},
	watch: {
		selectedRegion: function(val) {
			if ( val ) {
				let _ = this
				_.$emit('setValue', val)
			}
		},
		defaultId: function(val) {
			let _ = this
			_.getDetail(val)
		}
	}
}
</script>